const productCDDorCDI = {
  data() {
    return {
      productCDI: false
    }
  },
  methods: {
    labelPriceCDDorCDI(product){
      return product.isProductCDI ? `${product.contractType}CDI` : `${product.contractType}`;
    },
    isProductCDI(product){
      return !!product["isProductCDI"];
    },
    openModalHelp(product){
      this.productCDI = this.isProductCDI(product);
      this.showVariable = true
    }
  }
}

export default productCDDorCDI;



// WEBPACK FOOTER //
// ./src/mixins/productCDDorCDI.js